(() => {
  const mobile = window.matchMedia('(max-width: 639px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root = document) {
    root.querySelectorAll('.home-habits').forEach((group) => {
      if (group.dataset.enhanced) return;
      group.dataset.enhanced = 'true';
      const habits = [...group.querySelectorAll('.home-habit')];
      const update = () => habits.forEach((habit, index) => {
        habit.open = !mobile.matches || index === 0;
        const summary = habit.querySelector('summary');
        summary.tabIndex = mobile.matches ? 0 : -1;
        if (mobile.matches) summary.removeAttribute('aria-disabled');
        else summary.setAttribute('aria-disabled', 'true');
      });
      habits.forEach((habit) => habit.querySelector('summary').addEventListener('click', (event) => {
        if (!mobile.matches) event.preventDefault();
      }));
      mobile.addEventListener('change', update);
      update();
    });
    root.querySelectorAll('.home-selection').forEach((section) => {
      if (section.dataset.enhanced) return;
      section.dataset.enhanced = 'true';
      const rail = section.querySelector('.home-products');
      const controls = section.querySelector('.home-selection__controls');
      const previous = controls.querySelector('[data-products-prev]');
      const next = controls.querySelector('[data-products-next]');
      controls.hidden = false;
      const update = () => {
        previous.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        rail.tabIndex = mobile.matches ? 0 : -1;
      };
      const move = (direction) => {
        const card = rail.firstElementChild;
        const gap = parseFloat(getComputedStyle(rail).gap) || 0;
        rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(rail);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
